var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "accordion" },
    _vm._l(_vm.items, function (item, index) {
      return _c(
        "div",
        {
          class: {
            card: true,
            accordion__item: true,
            closed: !_vm.active[index],
          },
        },
        [
          _c(
            "h3",
            {
              staticClass: "accordion__title",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggle(index)
                },
              },
            },
            [_vm._v(_vm._s(item.title))]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "accordion__copy",
            style: { height: _vm.active[index] ? "auto" : "" },
            domProps: { innerHTML: _vm._s(item.content) },
          }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }